import { useQuery } from "@tanstack/react-query";
import { getPicksByGameId } from "../../../api";
import { useCurrentGameId } from "./use-current-game";

export function useCurrentGamePicks() {
  const gameId = useCurrentGameId();

  return useQuery({
    queryKey: ["games", gameId, "picks"],
    queryFn: async () => {
      return await getPicksByGameId(gameId);
    },
    enabled: !!gameId,
  });
}
